import { render, staticRenderFns } from "./SlaProvedorComponent.vue?vue&type=template&id=a6a3ff50"
import script from "./SlaProvedorComponent.vue?vue&type=script&lang=js"
export * from "./SlaProvedorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports